import { createReducer } from "@reduxjs/toolkit";
import initialState from "./cell-model.store";
import { CellModelActionType, changeRefinementRunStateSuccessful, getRefinementParametersFailure, getRefinementParametersSuccessful, loadCellModelDynamicNamesSuccessful, loadCellModelPopulationNamesSuccessful, loadCellModelSuccessful, loadCellModelVariablesSuccessful, setAddingPopulation, setCreateRefinedCellModelDialogStatus, setCurrentDynamic, setCurrentPopulation, setCurrentRefinementTab, setDependencyDialogStatus, setDisplayMode, setDynamicDialogStatus, setEditingPopulation, setHighlightMode, setPopulationEffectDialogStatus, setRefineDialogStatus, setRefinementData, setRefinementValidationErrors, setVariableDependencyGraphData, setVariableEffectDialogStatus, } from "./cell-model.actions";
import { prepareRefinementValidationErrors } from "./cell-model.utils";
import { reset } from "store/knowledge-base-item/knowledge-base-item.actions";
import { DialogStatus } from "shared/types";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(reset, () => initialState)
        .addCase(loadCellModelSuccessful, (state, { payload }) => {
        state.state = payload.state;
        state.inUse = payload.inUse === undefined ? state.inUse : payload.inUse;
    })
        .addCase(setDynamicDialogStatus, (state, { payload }) => {
        state.dynamicDialogStatus = payload;
    })
        .addCase(setDependencyDialogStatus, (state, { payload }) => {
        state.dependencyDialogStatus = payload;
    })
        .addCase(setVariableEffectDialogStatus, (state, { payload }) => {
        state.variableEffectDialogStatus = payload;
    })
        .addCase(setPopulationEffectDialogStatus, (state, { payload }) => {
        state.populationEffectDialogStatus = payload;
    })
        .addCase(setRefineDialogStatus, (state, { payload }) => {
        if (payload === DialogStatus.CLOSED) {
            state.refinementValidationErrors = undefined;
        }
        state.refineDialogStatus = payload;
    })
        .addCase(setCreateRefinedCellModelDialogStatus, (state, { payload }) => {
        state.createRefinedCellModelDialogStatus = payload;
    })
        .addCase(setRefinementData, (state, { payload }) => {
        state.refinement = payload.refinement;
        state.refined = payload.refined;
    })
        .addCase(changeRefinementRunStateSuccessful, (state, { payload }) => {
        if (state.refinement) {
            state.refinement.status = payload;
        }
    })
        .addCase(setCurrentDynamic, (state, { payload }) => {
        state.currentDynamicId = payload;
    })
        .addCase(setCurrentPopulation, (state, { payload }) => {
        state.currentPopulationId = payload;
    })
        .addCase(setEditingPopulation, (state, { payload }) => {
        state.editingPopulationId = payload;
    })
        .addCase(setAddingPopulation, (state, { payload }) => {
        state.addingPopulation = payload;
    })
        .addCase(loadCellModelVariablesSuccessful, (state, { payload }) => {
        state.variablesList = payload?.categories;
    })
        .addCase(loadCellModelPopulationNamesSuccessful, (state, { payload }) => {
        state.populationNames = payload;
    })
        .addCase(loadCellModelDynamicNamesSuccessful, (state, { payload }) => {
        state.dynamicNames = payload;
    })
        .addCase(setVariableDependencyGraphData, (state, { payload }) => {
        state.dependencyVariableGraphData = payload;
    })
        .addCase(getRefinementParametersSuccessful, (state, { payload }) => {
        state.refinementParameters = payload;
    })
        .addCase(getRefinementParametersFailure, (state) => {
        state.refinementParameters = [];
    })
        .addCase(setRefinementValidationErrors, (state, { payload }) => {
        state.refinementValidationErrors = prepareRefinementValidationErrors(payload);
    })
        .addCase(setHighlightMode, (state, { payload }) => {
        state.highlightedMode = payload;
    })
        .addCase(setDisplayMode, (state, { payload }) => {
        state.displayMode = payload;
    })
        .addCase(setCurrentRefinementTab, (state, { payload }) => {
        state.currentRefinementTab = payload;
    })
        .addMatcher((action) => [
        CellModelActionType.ADD_POPULATION_SUCCESSFUL,
        CellModelActionType.ADD_DYNAMIC_SUCCESSFUL,
        CellModelActionType.ADD_VARIABLE_SUCCESSFUL,
        CellModelActionType.DELETE_VARIABLE_SUCCESSFUL,
        CellModelActionType.EDIT_DYNAMIC_SUCCESSFUL,
        CellModelActionType.EDIT_POPULATION_SUCCESSFUL,
        CellModelActionType.DELETE_POPULATION_SUCCESSFUL,
        CellModelActionType.DELETE_DYNAMIC_SUCCESSFUL,
        CellModelActionType.ADD_POPULATION_EFFECT_SUCCESSFUL,
        CellModelActionType.UPDATE_POPULATION_EFFECT_SUCCESSFUL,
        CellModelActionType.DELETE_POPULATION_EFFECT_SUCCESSFUL,
        CellModelActionType.ADD_VARIABLE_DEPENDENCY_SUCCESSFUL,
        CellModelActionType.UPDATE_VARIABLE_DEPENDENCY_SUCCESSFUL,
        CellModelActionType.DELETE_VARIABLE_DEPENDENCY_SUCCESSFUL,
        CellModelActionType.ADD_VARIABLE_EFFECT_SUCCESSFUL,
        CellModelActionType.UPDATE_VARIABLE_EFFECT_SUCCESSFUL,
        CellModelActionType.DELETE_VARIABLE_EFFECT_SUCCESSFUL,
    ]
        .map(String)
        .includes(action.type), (state, { payload, type }) => {
        state.state = payload;
        if ([
            CellModelActionType.ADD_DYNAMIC_SUCCESSFUL,
            CellModelActionType.EDIT_DYNAMIC_SUCCESSFUL,
            CellModelActionType.ADD_POPULATION_EFFECT_SUCCESSFUL,
            CellModelActionType.UPDATE_POPULATION_EFFECT_SUCCESSFUL,
            CellModelActionType.DELETE_POPULATION_EFFECT_SUCCESSFUL,
            CellModelActionType.ADD_VARIABLE_DEPENDENCY_SUCCESSFUL,
            CellModelActionType.UPDATE_VARIABLE_DEPENDENCY_SUCCESSFUL,
            CellModelActionType.DELETE_VARIABLE_DEPENDENCY_SUCCESSFUL,
            CellModelActionType.ADD_VARIABLE_EFFECT_SUCCESSFUL,
            CellModelActionType.UPDATE_VARIABLE_EFFECT_SUCCESSFUL,
            CellModelActionType.DELETE_VARIABLE_EFFECT_SUCCESSFUL,
        ]
            .map(String)
            .includes(type)) {
            state.currentDynamicId = null;
            state.dynamicDialogStatus = DialogStatus.CLOSED;
            state.dependencyDialogStatus = DialogStatus.CLOSED;
            state.variableEffectDialogStatus = DialogStatus.CLOSED;
            state.populationEffectDialogStatus = DialogStatus.CLOSED;
        }
    });
});
